"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AdminList',
  components: {
    Pagination: _Pagination.default,
    // eslint-disable-next-line vue/no-unused-components
    selPlat: _selPlat.default,
    // eslint-disable-next-line vue/no-unused-components
    drawer: _filter.default
  },
  data: function data() {
    return {
      adminId: '',
      permissionMenu: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedKeys: [],
      dealPhone: _index.dealPhone,
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      },
      permissionDialog: false,
      permissionMinDialog: false,
      addAdminDialog: false,
      adminInfo: {
        nick_name: '',
        user_name: '',
        phone: '',
        email: '',
        password: '',
        admin_type: 2,
        add_source: 1,
        roles: ''
      },
      rolesName: [{
        'value': 'general',
        'name': '普通管理员'
      }, {
        'value': 'super',
        'name': '超级管理员'
      }]
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted(options) {
    this.getList();
    this.setAdminType();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      // eslint-disable-next-line prefer-const
      var listQuery = Object.assign({}, this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      var url = 'agentapi/admin';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start === 0) _this.tableMaxH = window.innerHeight - _this.$refs.order_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    setAdminType: function setAdminType() {
      if (this.checkRoles(['partner'])) {
        this.adminInfo.admin_type = 1;
      }
    },
    /**
     * 获取权限目录
     */
    getPermissionMenu: function getPermissionMenu() {
      var _this2 = this;
      var url = 'agentapi/menu';
      this.$get(url).then(function (res) {
        _this2.permissionMenu = res;
      });
    },
    /**
     * 获取后台管理员的权限
     */
    resetChecked: function resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    getAdminPermission: function getAdminPermission(row) {
      var _this3 = this;
      this.permissionDialog = true;
      this.$nextTick(function () {
        _this3.resetChecked();
      });
      var admindId = row.id;
      this.adminId = row.id;
      var url = 'agentapi/admin/role';
      this.$post(url, {
        'admin_id': admindId
      }).then(function (res) {
        _this3.permissionMenu = res.show_menu;
        _this3.checkedKeys = res.checked_keys;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    getMinPermission: function getMinPermission(row) {
      var _this4 = this;
      this.permissionMinDialog = true;
      this.$nextTick(function () {
        _this4.resetChecked();
      });
      var admindId = row.id;
      this.adminId = row.id;
      var url = 'agentapi/admin/mini_role';
      this.$post(url, {
        'admin_id': admindId
      }).then(function (res) {
        _this4.permissionMenu = res.show_menu;
        _this4.checkedKeys = res.checked_keys;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    handleCheckChange: function handleCheckChange() {
      this.checkedKeys = this.$refs.tree.getCheckedKeys();
    },
    addAdmin: function addAdmin() {
      this.addAdminDialog = true;
    },
    submitAdmin: function submitAdmin() {
      var _this5 = this;
      var params = this.adminInfo;
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });

      // 【操作埋点】2026-05-25 pc_permission_admin_add_1 添加管理员
      this.$post('agentapi/admin/add_admin', params).then(function (res) {
        _this5.$permissionReport.reportPermissionAdminAdd(params);
        _this5.loadObj.close();
        _this5.$message({
          message: '设置成功',
          type: 'success'
        });
        _this5.addAdminDialog = false;
        _this5.getList();
      }).catch(function () {
        _this5.loadObj.close();
      });
    },
    /**
     * 设置权限
     */
    setPermission: function setPermission() {
      var _this6 = this;
      var checkedKeys = this.checkedKeys.join(',');
      var params = {
        'admin_id': this.adminId,
        'role_id': checkedKeys
      };
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      // 【操作埋点】2026-05-25 pc_permission_role_set_1 PC 端权限分配
      this.$post('agentapi/admin/set/role', params).then(function (res) {
        var admin = _this6.list.find(function (item) {
          return item.id === _this6.adminId;
        });
        _this6.$permissionReport.reportPermissionRoleSet(_this6.adminId, admin ? admin.nick_name : '', checkedKeys, 'PC端');
        _this6.loadObj.close();
        _this6.$message({
          message: '设置成功',
          type: 'success'
        });
        _this6.permissionDialog = false;
      }).catch(function () {
        _this6.loadObj.close();
      });
    },
    setPermissionMin: function setPermissionMin() {
      var _this7 = this;
      var checkedKeys = this.checkedKeys.join(',');
      var params = {
        'admin_id': this.adminId,
        'role_id': checkedKeys,
        'type': 2
      };
      this.loadObj = this.$loading({
        lock: true,
        text: '提交中~~',
        spinner: 'el-icon-loading'
      });
      // 【操作埋点】2026-05-25 pc_permission_role_set_1 小程序权限分配
      this.$post('agentapi/admin/set/role', params).then(function (res) {
        var admin = _this7.list.find(function (item) {
          return item.id === _this7.adminId;
        });
        _this7.$permissionReport.reportPermissionRoleSet(_this7.adminId, admin ? admin.nick_name : '', checkedKeys, '小程序');
        _this7.loadObj.close();
        _this7.$message({
          message: '设置成功',
          type: 'success'
        });
        _this7.permissionMinDialog = false;
      }).catch(function () {
        _this7.loadObj.close();
      });
    }
  }
};